import { isNil, omitBy } from 'lodash'

import { Response } from '@marketplace-web/shared/api-client'
import { getSelectedDynamicFiltersArgs } from 'data/api/transformers/arguments/get-selected-dynamic-filters-args'
import { transformCatalogFiltersModelToParams } from 'data/api/transformers/arguments/transform-catalog-filters-model-to-params'
import { findThumbnail } from '@marketplace-web/shared/utils'
import { calculateRating } from 'data/utils/user-rating'

import {
  ClosetModel,
  ClosetUserModel,
  ClosetDto,
  ClosetPromotionUserDto,
  PromotedClosetsListResp,
  GetClosetPromotionArgs,
} from '../types/closet-promotions'

export const getClosetPromotionsArgsToParams = (args: GetClosetPromotionArgs) => {
  const staticArgs = {
    page: args.page,
    per_page: args.perPage,
    exclude_member_ids: args.excludedUserIds?.join(','),
    search_session_id: args.searchSessionId,
    screen_name: args.screenName,
    ...transformCatalogFiltersModelToParams(args),
  }

  return omitBy(
    { ...staticArgs, ...getSelectedDynamicFiltersArgs(args.selectedDynamicFilters) },
    isNil,
  )
}

export const transformClosetUser = (user: ClosetPromotionUserDto): ClosetUserModel => {
  return {
    id: user.id,
    name: user.login,
    image: findThumbnail(user.photo),
    rating: calculateRating(user.feedback_reputation),
    ratingCount: user.feedback_count,
    isFollowed: user.is_favourite,
    itemCount: user.item_count,
  }
}

export const transformCloset = (closet: ClosetDto): ClosetModel => {
  const { items, user } = closet

  return {
    user: transformClosetUser(user),
    items,
    showBanner: false,
  }
}

export const transformClosets = (data: Array<ClosetDto>): Array<ClosetModel> =>
  data.map(transformCloset)

export const transformClosetPromotionsResponse = (response: Response<PromotedClosetsListResp>) =>
  transformClosets(response.promoted_closets)
